'use client';

import React, { useState, useEffect } from 'react';
import { EmailSettings, EmailSettingsData } from '@contentgrowth/content-emailing/frontend';
import { useEmailService } from '@/app/admin-tools/api/email';
import { toast } from 'react-hot-toast';

export default function EmailSettingsPage() {
    const emailService = useEmailService();

    const loadSettings = async (): Promise<EmailSettingsData> => {
        const data = await emailService.getSettings();
        // Backend returns raw keys (system_email.provider OR provider if we mapped it)
        // Check my backend settings.js implementation: I returned keys WITHOUT prefix if we used my settings.js logic
        // "const cleanKey = row.key.slice(keyPrefix.length); settings[cleanKey] = row.value;"
        // So the keys are "provider", "fromName" etc. matching EmailSettingsData interface.
        return data as EmailSettingsData;
    };

    const saveSettings = async (settings: EmailSettingsData) => {
        try {
            await emailService.saveSettings(settings);
            toast.success('Settings saved successfully');
        } catch (error) {
            console.error(error);
            toast.error('Failed to save settings');
            throw error;
        }
    };

    const testSettings = async (settings: EmailSettingsData) => {
        try {
            const result = await emailService.testSettings(settings);
            if (result.success) {
                toast.success(result.message || 'Test email sent successfully');
                return { success: true, message: result.message };
            } else {
                toast.error(result.error || 'Test failed');
                return { success: false, error: result.error };
            }
        } catch (error: any) {
            console.error(error);
            const msg = error?.response?.data?.error || error.message || 'Test failed';
            toast.error(msg);
            return { success: false, error: msg };
        }
    };

    return (
        <div className="py-6">
            <EmailSettings
                onLoadSettings={loadSettings}
                onSaveSettings={saveSettings}
                onTestSettings={testSettings}
            />
        </div>
    );
}
